var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { NavigateDataType } from '../types/NavigateData';
import { logger, loggerError } from './Log';
export function navigateToMichelin(url, options, target) {
    if (target === void 0) { target = '_blank'; }
    var interval;
    try {
        logger('navigateToMichelin');
        var child_1 = window.open(url, target);
        var newOptions_1 = __assign({}, options);
        newOptions_1.origin = window.location.origin;
        interval = setInterval(function () {
            try {
                child_1.postMessage(newOptions_1, url);
            }
            catch (error) {
                clearInterval(interval);
            }
        }, 1500);
        var callback_1 = function (data) {
            logger('navigateToMichelin callback', data.data);
            if (data.data.type === NavigateDataType.NAVIGATE_SUCCESS) {
                clearInterval(interval);
                window.removeEventListener('message', callback_1);
                window.close();
            }
            clearInterval(interval);
        };
        window.addEventListener('message', callback_1);
        setTimeout(function () {
            window.close();
        }, 2000);
    }
    catch (error) {
        loggerError(error);
        clearInterval(interval);
    }
}
//# sourceMappingURL=navigateToMichelin.js.map